import styled from 'styled-components';


export const Banner = styled.div`
	width: 100%;
	height: 80vw;
	max-height: 534px;
	background-size: calc(100vw - 10px);
	background-repeat: no-repeat;
	background-position: 88% 100%;
	padding: 14px 15px 15px;
	border-radius: 6px;
	max-width: 600px;
	justify-self: center;

	@media all and (min-width: 768px) {
		background-size: cover;
		padding: 9px 15px 27px;
	}
	
	@media all and (min-width: 1024px) {
		background-size: cover;
		padding: 15px 15px 27px;
	}
	
	
	&:not(&.top-banner) {
		display: inline-flex;
		justify-content: center;
	}
	
	&.top-banner {
		background-position: 100% 100%;
		background-size: 650px;
		@media all and (min-width: 480px) {
			background-position: 93% 73%;
			background-size: 1000px;
		}
		@media all and (min-width: 768px) {
			background-position: 88% 70%;
			background-size: 1000px;
		}
		padding-top: 0;
	}
	
	> .content {
		display: inline-flex;
		flex-flow: column;
		align-items: center;
		justify-content: space-between;
		height: 100%;
		width: 100%;
		
		.title {
			border-radius: 22.865px;
			border: 0.5px solid #FFF;
			padding: 3px 6px;

			background: linear-gradient(270deg, rgba(255, 255, 255, 0.62) -65.9%, rgba(255, 255, 255, 0.00) 160.44%);

			box-shadow: 0 1.82917px 4.57292px 0px rgba(255, 255, 255, 0.25) inset, 0px 1.82917px 1.82917px 0px rgba(0, 0, 0, 0.10);
			backdrop-filter: blur(15px);
			width: 100%;
			max-width: 450px;

			color: #FFF;
			text-align: center;
			font-size: 10px;
			font-style: normal;
			font-weight: 800;
			line-height: normal;
			text-transform: uppercase;
			&.dark {
				color: #001644;
			}
		}
	}
	
	@media all and (min-width: 768px) {
		max-height: 432px;
		height: 30vw;
		background-position: 25% 100%;
		
		.content {
			width: 100%;
		}


		&.top-banner {
			height: 386px;
			padding: 0 46px 46px;
			background-size: cover;
			background-position: center 88%;
			max-width: unset;
			
			.content {
				width: 550px;
			}
		}
	}
`
export const GridLayout = styled.div`
	display: grid;
	grid-template-columns: auto;
	grid-template-rows: auto auto auto;
	grid-gap: 14px;
	
	
	//@media all and (min-width: 768px) and (max-width: 991px) {
	//	grid-template-columns: 1fr 1fr;
	//	grid-template-rows: auto auto;
	//
	//	> div {
	//		height: 400px;
	//		background-position: 35% 100%;
	//	}
	//}
	
	@media all and (min-width: 768px) {

		grid-template-columns: 1fr 1fr 1fr;
		grid-template-rows: auto auto;

		> div:first-child {
			grid-column-start: 1;
			grid-column-end: 4;
			grid-row-start: 1;
			grid-row-end: 1;
		}
}
`
